import { create } from "zustand";
import type { AuthUser } from "../auth/auth.types";
import type { GetGyulDebtResponse, GetMeResponse, UpdateMeResponse } from "./user.types";

type UserState = {
	me: GetMeResponse | UpdateMeResponse | AuthUser | null;
	gyulDebt: GetGyulDebtResponse | null;
	setMe: (me: GetMeResponse | UpdateMeResponse | AuthUser | null) => void;
	setGyulDebt: (gyulDebt: GetGyulDebtResponse | null) => void;
	clear: () => void;
};

export const useUserStore = create<UserState>((set) => ({
	me: null,
	gyulDebt: null,
	setMe: (me) => set({ me }),
	setGyulDebt: (gyulDebt) => set({ gyulDebt }),
	clear: () => set({ me: null, gyulDebt: null }),
}));
